import { useEffect, useState } from 'react';
import Table from '../tables/Table';
import axios from 'axios';
import {  useNavigate } from 'react-router-dom';
import { DateTime } from 'luxon';

export default function FlexList(props) {
   const navigate = useNavigate();
  const [headers, setHeaders] = useState(props.headers);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('start');

  useEffect(() => {
    if (props.headers) {
      setHeaders(props.headers);
    }
    setStatus('loading');
    axios.get(props.url, { withCredentials: true })
      .then(response => {
        const sorted = sortDataBy(response.data);
        setData(sorted);
        setStatus('done');
      })
      .catch(err => {
        if(err.response.status === 401 ){
          console.log(err);
          navigate('/login');
        }else{
          setStatus('error');
          console.log(err);
        }
        
      });
  }, [props.headers, props.url, navigate,props.done]);

  const sortDataBy = (data) => {
    if (!props.sort) return data;

    return [...data].sort((a, b) => {
      const dateA = DateTime.fromISO(a.dateTime);
      const dateB = DateTime.fromISO(b.dateTime);

      if (props.sort === 'asc') {
        return dateA.toMillis() - dateB.toMillis();
      } else {
        return dateB.toMillis() - dateA.toMillis();
      }
    });
  };

  return (
    <div style={{width:'100%'}}>
      <h3>{props.name}</h3>
      <Table headers={headers} props={props}
      label={props.label}  
      onRefreshHundler={props.onRefreshHundler} 
      stateHundler={props.stateHundler} 
      table={props.table} 
      thead={props.thead} htr={props.htr}
      th={props.th} tbody={props.tbody} btr={props.btr} td={props.td} 
      data={data} status={status} />
    </div>
  )
}
